<div class="row py-2" [class.align-items-baseline]="alignBaseline()">
  <div class="col-6">
    <span>{{ label() }}</span>
  </div>
  <div class="col-6 text-end text-md-start">
    <span class="fw-semi-bold">{{ value() }}</span>
  </div>
</div>
